<template>
  <component :is="layout" translate="no">
    <router-view />
    <alert-modal />
  </component>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import AlertModal from '@/components/designSystem/Alerts/index.vue'
import { resolveLayout } from '@/utils/layout'
import { isCompanyAuthenticated } from '@/utils/storage'

const { currentRoute } = useRouter()

const layout = computed(() => resolveLayout(currentRoute.value, isCompanyAuthenticated()))
</script>

<style>
#app {
  font-family: Inter, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  .v-input--is-focused .v-input__slot {
    border: 2px solid #005fcc !important;
    border-bottom-color: rgba(255, 13, 13, 0.38) !important;
  }
}

.theme--light.v-text-field--filled > .v-input__control > .v-input__slot {
  background: #ffffff;
  border: 1px solid red;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;

  &:before {
    display: none;
  }
}
</style>
